import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import {ref, provide, onBeforeMount, onBeforeUnmount} from 'vue';
    import {PrismicDocument} from '@prismicio/types';
    import {getPageLocale} from '@malt/dom';
    import {getNavbarDocument} from '@/unlogged/api/prismic';
    import CountryLaunchingBanner from './components/CountryLaunchingBanner.vue';
    import NavigationHeader from './components/NavigationHeader.vue';
    import NavigationHeaderLoader from './components/NavigationHeaderLoader.vue';
    import {MEDIA_BREAKPOINTS} from './keys';
    import {useBreakpointsHelper} from './composables/useBreakpointsHelpers';
    import {useWindowNavGlobals} from './composables/useWindowNavGlobals';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

    const breakpoints = ref(useBreakpointsHelper());
    provide(MEDIA_BREAKPOINTS, breakpoints);
    function handleResize() {
        breakpoints.value = useBreakpointsHelper();
    }
    onBeforeMount(() => {
        window.addEventListener('resize', handleResize);
    });
    onBeforeUnmount(() => {
        window.removeEventListener('resize', handleResize);
    });

    const {searchFormVisible} = useWindowNavGlobals();

    const navbarDocument = ref<PrismicDocument>();

    document.body.classList.add('navbar-unlogged');
    if (searchFormVisible.value) {
        document.body.classList.add('WITH_SEARCH_FORM');
    }

    getNavbarDocument(getPageLocale() ?? 'fr-FR').then((document) => {
        navbarDocument.value = document;
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CountryLaunchingBanner),
    (navbarDocument.value?.data !== undefined)
      ? (_openBlock(), _createBlock(NavigationHeader, {
          key: 0,
          "navbar-document": navbarDocument.value
        }, null, 8, ["navbar-document"]))
      : (_openBlock(), _createBlock(NavigationHeaderLoader, { key: 1 }))
  ], 64))
}
}

})